<script setup lang="ts">
/**
 * Screen size aware drawer modal that renders OzDrawer on phone and OzSideModal on tablet/desktop. Used in surface panels.
 */
import OzDrawerDraggable from '@@/library/v4/components/OzDrawerDraggable.vue'
import OzDrawerStatic from '@@/library/v4/components/OzDrawerStatic.vue'
import OzSideModal from '@@/library/v4/components/OzSideModal.vue'

withDefaults(
  defineProps<{
    isPhone?: boolean
    isDraggableDrawer?: boolean
  }>(),
  {
    isPhone: false,
    isDraggableDrawer: false,
  },
)

defineEmits(['scrim-click', 'scrim-esc', 'swipedown', 'swipeup', 'trigger-anchor-update', 'transition:after-enter'])
</script>

<script lang="ts">
export default {}
</script>

<template>
  <OzDrawerStatic
    v-if="isPhone && !isDraggableDrawer"
    v-bind="{ ...$props, ...$attrs }"
    @scrim-click="$emit('scrim-click')"
    @scrim-esc="$emit('scrim-esc')"
  >
    <template #header="{ scrollTop }"><slot name="header" :scroll-top="scrollTop" /></template>
    <template #body><slot name="body" /></template>
  </OzDrawerStatic>
  <OzDrawerDraggable
    v-else-if="isPhone && isDraggableDrawer"
    v-bind="{ ...$props, ...$attrs }"
    @scrim-click="$emit('scrim-click')"
    @scrim-esc="$emit('scrim-esc')"
    @swipedown="$emit('swipedown', $event)"
    @swipeup="$emit('swipeup', $event)"
  >
    <template #header><slot name="header" /></template>
    <template #body><slot name="body" /></template>
  </OzDrawerDraggable>
  <OzSideModal
    v-else
    v-bind="{ ...$props, ...$attrs }"
    @scrim-click="$emit('scrim-click')"
    @scrim-esc="$emit('scrim-esc')"
    @transition:after-enter="$emit('transition:after-enter', $event)"
  >
    <template #header="{ scrollTop }"><slot name="header" :scroll-top="scrollTop" /></template>
    <template #body><slot name="body" /></template>
  </OzSideModal>
</template>
